import React, { useRef, useEffect, useState } from 'react';
import { AvailableColorMetaFieldData } from '../../_shared/types';
import AloPopper from '../../_shared/ui-components/Popper';
import { hasHiddenInventoryTag } from 'src/scripts/utils/plp-pdp-shared';
import { checkIfItemCanBeSoldOut } from 'src/scripts/utils/helpers';

interface SwatchUIButtonProps {
  active?: boolean;
  className?: string;
  'swatch-name'?: string;
  onClick?: () => void;
}

export const SwatchUI = ({
  colorData,
  tooltipMessage,
  _isComingSoon,
  buttonProps = {},
  isFirstSwatch = false,
}: {
  colorData: AvailableColorMetaFieldData;
  tooltipMessage?: string | null;
  _isComingSoon?: boolean;
  //-- use TS extend, add annotations for HTML native button props w/ buttonProps together
  buttonProps?: SwatchUIButtonProps;
  isFirstSwatch: boolean;
}) => {
  const tooltipPlacement = useRef<HTMLButtonElement | null>(null);
  const tooltipContainer = useRef<HTMLDivElement | null>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const shouldHideInventory = hasHiddenInventoryTag(colorData.tags);
  const isSoldOut = checkIfItemCanBeSoldOut(colorData.tags)
    ? (shouldHideInventory || colorData.totalInventory <= 0) && !_isComingSoon
    : false;

  tooltipMessage = isSoldOut ? 'Sold Out' : tooltipMessage;
  // ? [REVISIT] extract shared logic from PDP
  const { swatch: { sections: swatchSections = [] } = {} } = colorData;
  const swatchUIStyles: React.CSSProperties = {
    backgroundColor: 'var(--white)',
  };
  if (swatchSections[0]?.image) {
    // With this linear-gradient approach below, we can't do gradients with images.
    // Instead, if the first section is an image, we show that and ignore the other sections.
    swatchUIStyles.backgroundImage = `url("${swatchSections[0].image}")`;
  } else if (swatchSections.length === 1) {
    swatchUIStyles.backgroundColor = swatchSections[0]!.color;
  } else if (swatchSections.length === 2) {
    swatchUIStyles.backgroundImage = `linear-gradient(${swatchSections[0]!.color} 50%, 50%, ${
      swatchSections[1]!.color
    } 100%)`;
  } else if (swatchSections.length >= 3) {
    swatchUIStyles.backgroundImage = `linear-gradient(${swatchSections[0]!.color} 33%, 33%, ${
      swatchSections[1]!.color
    } 66%, 66%, ${swatchSections[2]!.color} 100%)`;
  }
  const swatchUIClassName = `SwatchUI ${buttonProps.className || ''} ${buttonProps.active ? 'active' : ''}`;

  useEffect(() => {
    setShowTooltip(!!(tooltipMessage && tooltipMessage.length > 1 && buttonProps.active));
  }, [tooltipMessage, buttonProps.active]);

  return (
    // ? [REVISIT] aria / tabindex
    <div ref={tooltipContainer} style={{ position: 'relative', display: 'grid', placeItems: 'center' }}>
      <button
        type="button"
        ref={tooltipPlacement}
        title={buttonProps['swatch-name']}
        aria-label={buttonProps['swatch-name']}
        onClick={buttonProps.onClick}
        style={swatchUIStyles}
        className={swatchUIClassName}
      />
      {isSoldOut ? (
        <span className="swatch-disabled-ui">
          <span className="line" />
        </span>
      ) : null}
      {tooltipPlacement.current && showTooltip ? (
        <AloPopper
          text={tooltipMessage || ''}
          isOpen={showTooltip}
          anchorEl={tooltipPlacement.current}
          placement={isFirstSwatch ? 'top-start' : 'top'}
          container={tooltipContainer.current}
          styles={{ zIndex: 2 }}
        />
      ) : null}
    </div>
  );
};
